'use client';

import { type ReactNode } from 'react';
import SalesCallbackProvider from '@/components/sales-callback/SalesCallbackProvider';
import type { ContactForm } from '@/types/contact-forms';

interface CompanyProfileShellProps {
  children: ReactNode;
  emailContactForm?: ContactForm | null;
}

export default function CompanyProfileShell({
  children,
  emailContactForm,
}: CompanyProfileShellProps) {
  return (
    <SalesCallbackProvider variant="corporate" formConfig={emailContactForm}>
      {children}
    </SalesCallbackProvider>
  );
}
